import { extendTheme } from '@chakra-ui/react';

import { radii } from './border-radius';
import { breakpoints } from './breakpoints';
import { colors } from './colors';
import { components } from './components';
import { fontSizes } from './font-sizes';
import { fontWeights } from './font-weights';
import { fonts } from './fonts';
import { letterSpacings } from './letter-spacing';
import { lineHeights } from './line-heights';
import { semanticTokens } from './semantic-tokens';
import { shadows } from './shadows';
import { space } from './spacing';
import { styles } from './styles';

export type Extension = Parameters<typeof extendTheme>[number];

export const theme = extendTheme({
	initialColorMode: 'light',
	useSystemColorMode: false,
	breakpoints,
	colors,
	components,
	fonts,
	fontSizes,
	fontWeights,
	letterSpacings,
	lineHeights,
	radii,
	semanticTokens,
	shadows,
	space,
	styles,
});

export const createTheme = (extension?: Extension) => (extension ? extendTheme(theme, extension) : theme);
